import { defineMessages } from 'react-intl';

export default defineMessages({
  resendLinkText: {
    id: 'CreatePasswordForm.resendLinkText',
    description: 'Resend code Text',
    defaultMessage: 'Didn\'t receive an email?',
  },
  resendLinkButtonText: {
    id: 'CreatePasswordForm.resendLinkButtonText',
    description: 'Resend code Button Text',
    defaultMessage: 'Resend',
  },
  resentConfirmMessagePart1: {
    id: 'CreatePasswordForm.resentConfirmMessagePart1',
    description: 'Resent code confirmation message part1',
    defaultMessage: 'We have sent another verification code to',
  },
  resentConfirmMessagePart2: {
    id: 'CreatePasswordForm.resentConfirmMessagePart2',
    description: 'Resent code confirmation message part2',
    defaultMessage: 'It may take a few minutes',
  },
  codeSentConfirmMessage: {
    id: 'CreatePasswordForm.codeSentConfirmMessage',
    description: 'Code confirmation message',
    defaultMessage: 'Sent mail to',
  },
  customerCareHelp: {
    id: 'CreatePasswordForm.customerCareHelp',
    description: 'Customer care Help',
    defaultMessage: 'Need more help?',
  },
  customerCareHelpText: {
    id: 'CreatePasswordForm.customerCareHelpText',
    description: 'Customer care Help text',
    defaultMessage: 'If youre still having difficulty logging into your account, please call our customer service representatives at',
  },
  customerCareHelpQuestions: {
    id: 'CreatePasswordForm.customerCareHelpQuestions',
    description: 'Customer care Help questions',
    defaultMessage: 'Questions?',
  },
  customerCareHelpQuestionsText: {
    id: 'CreatePasswordForm.customerCareHelpQuestionsText',
    description: 'Customer care Help questions Text',
    defaultMessage: 'Visit our',
  },
  customerCareHelpFAQsText: {
    id: 'CreatePasswordForm.customerCareHelpFAQsText',
    description: 'Customer care FAQs Text',
    defaultMessage: 'FAQs',
  },
  passwordError: {
    id: 'CreatePasswordForm.passwordErr',
    description: 'Password Field Error Message',
    defaultMessage: 'Enter a password. Field cannot be blank.',
  },
  passwordLengthError: {
    id: 'CreatePasswordForm.passwordLengthError',
    description: 'PasswordValidation length validation text',
    defaultMessage: '10 characters minimum',
  },
  passwordMatchError: {
    id: 'CreatePasswordForm.passwordMatchError',
    description: 'Password Match Error Message',
    defaultMessage: 'Passwords should match.',
  },
  verificationCodeRequired: {
    id: 'CreatePasswordForm.verificationCodeRequired',
    description: 'Verification code is required',
    defaultMessage: 'Verification code is required',
  },
  verificationCodeLengthError: {
    id: 'CreatePasswordForm.verificationCodeLengthError',
    description: 'Verification code must be 6 digits.',
    defaultMessage: 'Verification code must be 6 digits.',
  },

  verificationCodeMismatchException: {
    id: 'CreatePasswordForm.verificationCodeMismatchException',
    description: 'Code is incorrect. Please try again.',
    defaultMessage: 'Code is incorrect. Please try again.',
  },

  verificationCodeExpiredCodeException: {
    id: 'CreatePasswordForm.verificationCodeExpiredCodeException',
    description: 'Verification code is expired.',
    defaultMessage: 'Verification code is expired.',
  },

  verificationCodeResetLimitExceeded: {
    id: 'CreatePasswordForm.verificationCodeResetLimitExceeded',
    description: 'Verification code reset Maximum time limit exceeded',
    defaultMessage: 'Maximum time limit exceeded. Please try again later.',
  },
});
